import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import { registerResettable } from './reset';
import { type AuthStore, createAuthStore } from './session-auth';
import { createEnvStore, type EnvStore } from './session-env';

export type { AuthState, AuthStore } from './session-auth';
export type { EnvState, EnvStore } from './session-env';
export { defaultSiteEnv, type EnvFallback } from './session-env';
export type { HostAvailableTeam, HostTeam, HostUser } from './session-types';

export type SessionStores = {
  useAuthStore: AuthStore;
  useEnvStore: EnvStore;
};

/**
 * Builds the auth/env stores together, wired to the host's `apiHandler` - the composition root a
 * host calls once (`src/lib/session.ts` for spark-dash) and threads the two hooks through from
 * there. Auth clears env on login/logout, so its factory is handed the shared `stores` object to
 * reach env at call time.
 */
export function createSessionStores(apiHandler: ApiHandlerContract): SessionStores {
  const stores = {} as SessionStores;

  stores.useEnvStore = createEnvStore(apiHandler);
  stores.useAuthStore = createAuthStore(apiHandler, stores);

  registerResettable(stores.useEnvStore);
  registerResettable(stores.useAuthStore);

  return stores;
}
